var $ = require('../internals/export');
var global = require('../internals/global');
var setToStringTag = require('../internals/set-to-string-tag');

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.reflect.to-string-tag.js
// module id = 206
// module chunks = 49